import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

export interface SystemPlatformListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
}

const defaultFilters: SystemPlatformListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "systemName",
    sortOrder: "asc"
};

export const useSystemPlatformListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<SystemPlatformListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<SystemPlatformListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [location.pathname, history, filters]);

    const setSort = (sort: ListTableSort) => {
        setFilters((prevFilters: SystemPlatformListingFilters) => ({
            ...prevFilters,
            sortBy: sort.by,
            sortOrder: sort.order,
            page: 1
        }));
    };

    const setPage = (page: number) => {
        setFilters((prevFilters: SystemPlatformListingFilters) => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters((prevFilters: SystemPlatformListingFilters) => ({ ...prevFilters, pageSize, page: 1 }));
    };

    return {
        filters,
        setPage,
        setPageSize,
        setSort
    };
};
